import { useMemo } from 'react'
import _ from 'lodash'
import { useFormSelector } from '../../../redux/formStoreHooks'
import L3SecondaryCodingTable from '../l3/L3SecondaryCodingTable'
import { RenderMedia, SecondaryCode } from "@fusion-advantage/backcompat"
import { secondaryCodeCompare } from '@fusion-advantage/formlib'

const L4SecondaryCodingTable = () => {
	const stateCodes = useFormSelector(state => state.diagnosisReview.secondaryCodes)
	const media = useFormSelector(state => state.render.media)
	const resultingDx = useFormSelector(state => state.diagnosisReview.resultingDiagnosis)

	const models = useMemo((): SecondaryCode[]|null => {
		// [FA-217]
		// If the auditor clicks the Run Combo Codes button, in all cases we want
		// to refresh the secondary table by calling Secondary Codes API endpoint
		// and displaying the data fresh from the endpoint.
		if(_.isArray(stateCodes)) {
			return [...stateCodes].sort(secondaryCodeCompare)
		}
		// [FA-217]
		// If the result/concept status value for "[GeneralConcepts] Resulting
		// Diagnosis" is not null and has more than one item in the array,
		// and the media is Print,
		// then validate and display the concept status value data
		// and display in the secondary codes table.
		else if(media === RenderMedia.Print) {
			if(resultingDx && resultingDx.length >= 1) {
				return [...resultingDx].sort(secondaryCodeCompare)
			}
		}
		return null
	}, [stateCodes, media, resultingDx])

	if(models) {
		return <L3SecondaryCodingTable models={models} />
	}
	
	return null
}

export default L4SecondaryCodingTable
